// extracted by mini-css-extract-plugin
export default {"itemHovered":"styles_itemHovered__STFRr","completeButton":"styles_completeButton__BjHr8"};